// Tracks which notice_id the viewer has already acknowledged. The owner
// republishing a notice generates a new notice_id, which makes this stored
// value mismatch and the overlay shows again. Cross-tab via storage events
// is not needed — the overlay is a one-shot per page load.
const STORAGE_KEY = "crt_notice_ack";

export function getAckedNoticeId() {
  try { return localStorage.getItem(STORAGE_KEY) || ""; } catch (e) { return ""; }
}

export function ackNotice(noticeId) {
  if (!noticeId) return;
  try { localStorage.setItem(STORAGE_KEY, noticeId); } catch (e) { /* noop */ }
}
